import { BaseDto } from './base.dto';

export class AreaCoordinatesDto extends BaseDto {
  id: number;
  areaId: number;
  latitude: string;
  logitude: string;
  startDate: Date;
  endDate?: Date;
}
